import { useRef } from 'react';

interface Props {
  onStart?: () => void;
  onFinish?: () => void;
  onCancel?: () => void;
  delay?: number;
}
export function useLongPress({ onStart, onFinish, onCancel, delay = 2000 }: Props) {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const successRef = useRef(false);

  const start = () => {
    successRef.current = false;

    onStart?.();

    timerRef.current = setTimeout(() => {
      successRef.current = true;

      onFinish?.();
    }, delay);
  };

  const clear = () => {
    clearTimeout(timerRef.current ?? undefined);

    if (!successRef.current) {
      onCancel?.();
    }
  };

  return {
    onMouseDown: start,
    onMouseUp: clear,
    onMouseLeave: clear,
    onTouchStart: start,
    onTouchEnd: clear,
  };
}
